import React, {ReactElement} from 'react';
import {Grid, makeStyles, Typography} from '@material-ui/core';
// import {useTranslation} from 'react-i18next';
import logo from 'images/logo-bella-aurora.svg';
import FlexBox from 'shared/components/ui/FlexBox';

const useStyles = makeStyles(theme => ({
  container: {
    minHeight: '100vh'
  },
  image: {
    display: 'block',
    width: '100%',
    height: 'auto'
  },
  textsBox: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    textAlign: 'center'
  },
  title: {
    fontWeight: 400
  },
  text: {
    marginTop: theme.spacing(4),
    fontSize: theme.typography.h3.fontSize
  },
  support: {
    marginTop: theme.spacing(2),
    textAlign: 'center'
  }
}));

function PageNotFound(): ReactElement {
  const classes = useStyles();
  // const {t} = useTranslation(['common']);
  return (
    <FlexBox className={classes.container} flexDirection="column" justifyContent="center">
      <Grid container justifyContent="center">
        <Grid item lg={3} md={6}>
          <img src={logo} className={classes.image} alt="Bella Aurora" />
          <div className={classes.textsBox}>
            <Typography variant="h3">Se ha producido un error</Typography>
            <Typography variant="h2" className={classes.title}>
              Sentimos los inconvenientes ocasionados.
            </Typography>
            {/* <Typography
              className={classes.text}
              dangerouslySetInnerHTML={{
                __html: t('common:notFoundPage.text', {interpolation: {escapeValue: false}})
              }}
            /> */}
          </div>
          {/* <img src={robotBody} className={classes.image} /> */}
        </Grid>
      </Grid>
      {/* <Typography
        className={classes.support}
        dangerouslySetInnerHTML={{
          __html: t('common:notFoundPage.support', {interpolation: {escapeValue: false}})
        }}
      /> */}
    </FlexBox>
  );
}

export default PageNotFound;
